import { resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "dialog-wrapper" };
const _hoisted_2 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_3 = { class: "require-field-wrapper pa-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_form = _resolveComponent("v-form");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_icon = _resolveComponent("v-icon");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.dialog) = $event)),
        "content-class": "responsive-dialog",
        "onClick:outside": _ctx.handleClickCancel,
        onKeydown: _withKeys(_ctx.handleClickCancel, ["esc"])
    }, {
        activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps(props, {
                variant: "outlined",
                block: "",
                class: "add-option-btn",
                disabled: !_ctx.getterSelectedFeeGroupId,
                onClick: _ctx.handleClickOpenDialogBtn
            }), {
                default: _withCtx(() => [
                    _createVNode(_component_v_icon, { small: "" }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createTextVNode(" mdi-plus ")
                        ])),
                        _: 1 /* STABLE */,
                        __: [8]
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.lc}add_title`)), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
            }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["disabled", "onClick"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_DialogHeader, {
                    title: _ctx.$t(`${_ctx.lc}add_title`),
                    "on-cancel": _ctx.handleClickCancel
                }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                _createVNode(_component_v_form, {
                    ref: "formRef",
                    modelValue: _ctx.formValid,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.formValid) = $event)),
                    onSubmit: _withModifiers(_ctx.handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createCommentVNode(" 대행료 시작 금액 "),
                                _createVNode(_component_InputRow, {
                                    label: _ctx.$t(`${_ctx.lc}from_amount`),
                                    "is-required": "",
                                    "is-vertical-label": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.formattedFromAmountComputed,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formattedFromAmountComputed) = $event)),
                                            variant: "outlined",
                                            dense: "",
                                            "hide-details": "auto",
                                            "single-line": "",
                                            "validate-on": "blur",
                                            placeholder: _ctx.$t('common.amount_required'),
                                            suffix: _ctx.$t('unit.currency'),
                                            error: _ctx.isDuplicatedError,
                                            rules: _ctx.formRules.fromAmount,
                                            maxlength: _ctx.WORKER_FEE_GROUP_OPTION_AMOUNT_MAX_LENGTH,
                                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                            onFocus: _ctx.onFocusAmountField
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "suffix", "error", "rules", "maxlength", "onFocus"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"]),
                                _createCommentVNode(" 대행료 종료 금액 "),
                                _createVNode(_component_InputRow, {
                                    label: _ctx.$t(`${_ctx.lc}to_amount`),
                                    "is-required": "",
                                    "is-vertical-label": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.formattedToAmountComputed,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.formattedToAmountComputed) = $event)),
                                            variant: "outlined",
                                            dense: "",
                                            "hide-details": "auto",
                                            "single-line": "",
                                            "validate-on": "blur",
                                            placeholder: _ctx.$t('common.amount_required'),
                                            suffix: _ctx.$t('unit.currency'),
                                            error: _ctx.isDuplicatedError,
                                            rules: _ctx.formRules.toAmount,
                                            maxlength: _ctx.WORKER_FEE_GROUP_OPTION_AMOUNT_MAX_LENGTH,
                                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                            onFocus: _ctx.onFocusAmountField
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "suffix", "error", "rules", "maxlength", "onFocus"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"]),
                                _createCommentVNode(" 수수료 "),
                                _createVNode(_component_InputRow, {
                                    label: _ctx.$t(`${_ctx.lc}fee`),
                                    "is-required": "",
                                    "is-vertical-label": ""
                                }, {
                                    default: _withCtx(() => [
                                        _createCommentVNode(" 수수료 원 "),
                                        _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.formattedFeeComputed,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formattedFeeComputed) = $event)),
                                            class: "pb-4",
                                            variant: "outlined",
                                            dense: "",
                                            "hide-details": "auto",
                                            "single-line": "",
                                            "validate-on": "blur",
                                            placeholder: _ctx.$t('common.amount_required'),
                                            suffix: _ctx.$t('unit.currency'),
                                            oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                            onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.onBlurFeeField(_ctx.formattedFeeComputed)))
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "suffix"]),
                                        _createCommentVNode(" 수수료 % "),
                                        _createVNode(_component_v_text_field, {
                                            modelValue: _ctx.rateComputed,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.rateComputed) = $event)),
                                            variant: "outlined",
                                            dense: "",
                                            "hide-details": "auto",
                                            "single-line": "",
                                            "validate-on": "blur",
                                            placeholder: _ctx.$t(`common.percent_required`),
                                            suffix: _ctx.$t('unit.percent'),
                                            rules: _ctx.formRules.rate,
                                            maxlength: _ctx.WORKER_FEE_GROUP_OPTION_RATE_MAX_LENGTH,
                                            oninput: "javascript: this.value = this.value.replace(/[^0-9|.]/g, '' );",
                                            onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.onBlurRateField(_ctx.rateComputed)))
                                        }, null, 8 /* PROPS */, ["modelValue", "placeholder", "suffix", "rules", "maxlength"])
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["label"])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "onSubmit"]),
                _createVNode(_component_v_divider),
                _createVNode(_component_DialogFooter, {
                    cancel: "",
                    ok: "",
                    "on-cancel": _ctx.handleClickCancel,
                    "on-ok": _ctx.handleClickOk
                }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
            ])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onClick:outside", "onKeydown"]));
}
